import React, { useMemo, useEffect } from 'react';
import itly from 'itly';
import { useChatContext } from '../ChatContext';
import {
  SampleQuestionsButton,
  SampleQuestionsButtonsContainer,
  SampleQuestionsContainer,
  SampleQuestionsTitle,
  ScrollButton,
  QuestionsWrapper
} from './styles';
import { useSampleQuestionsScrolling } from './useSampleQuestionsScrolling';
import { useSampleQuestions } from '../useSampleQuestions';

export const SampleQuestions = ({ handleClick }: { handleClick: (e: any, index: number) => void }): JSX.Element => {
  const { messages, isInputFocused } = useChatContext();
  const sampleQuestions = useSampleQuestions();

  const isOpen = useMemo(() => !messages?.length && !isInputFocused, [isInputFocused, messages?.length]);

  const { containerRef, canScrollLeft, canScrollRight, hasOverflow, scroll, checkScroll } = useSampleQuestionsScrolling(
    {
      questionsCount: sampleQuestions.length,
      isOpen
    }
  );

  useEffect(
    function resetScroll() {
      containerRef.current.scrollLeft = 0;
    },
    [containerRef, messages]
  );

  return (
    <SampleQuestionsContainer id="chat-sample-questions-container" isOpen={isOpen}>
      <SampleQuestionsTitle>Questions to get you started</SampleQuestionsTitle>
      <QuestionsWrapper leftGradient={canScrollLeft} rightGradient={canScrollRight}>
        {hasOverflow && canScrollLeft && (
          <ScrollButton
            className="left"
            onClick={() => {
              itly.productAssistantSampleQuestionArrowClicked({ arrow: 'left', current_url: window.location.href });
              scroll('left');
            }}
            aria-label="Scroll left"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.3155 21.9281C17.8281 21.4155 17.8281 20.5845 17.3155 20.0719L9.24361 12L17.3155 3.92808C17.8281 3.41551 17.8281 2.58448 17.3155 2.07192C16.803 1.55936 15.9719 1.55936 15.4594 2.07192L6.45937 11.0719C5.94681 11.5845 5.94681 12.4155 6.45937 12.9281L15.4594 21.9281C15.9719 22.4406 16.803 22.4406 17.3155 21.9281Z"
                fill="#333333"
              />
            </svg>
          </ScrollButton>
        )}
        <SampleQuestionsButtonsContainer
          ref={containerRef}
          className={`enable-wheel ${hasOverflow ? 'has-overflow' : ''}`}
          onScroll={checkScroll}
        >
          {sampleQuestions.map((question, index) => {
            return (
              <SampleQuestionsButton
                key={`sample-question-${index}`}
                onClick={() => handleClick(question.question, index)}
                aria-label={`Ask question: ${question.question}`}
              >
                {question.question}
              </SampleQuestionsButton>
            );
          })}
        </SampleQuestionsButtonsContainer>
        {hasOverflow && canScrollRight && (
          <ScrollButton
            className="right"
            onClick={() => {
              itly.productAssistantSampleQuestionArrowClicked({ arrow: 'right', current_url: window.location.href });
              scroll('right');
            }}
            aria-label="Scroll right"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.68447 21.9281C6.17191 21.4155 6.17191 20.5845 6.68447 20.0719L14.7564 12L6.68447 3.92808C6.17191 3.41551 6.17191 2.58448 6.68447 2.07192C7.19703 1.55936 8.02806 1.55936 8.54063 2.07192L17.5406 11.0719C18.0532 11.5845 18.0532 12.4155 17.5406 12.9281L8.54063 21.9281C8.02806 22.4406 7.19703 22.4406 6.68447 21.9281Z"
                fill="#333333"
              />
            </svg>
          </ScrollButton>
        )}
      </QuestionsWrapper>
    </SampleQuestionsContainer>
  );
};
